// @flow
import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import theme from '../../theme-config';
import I18n from '../../lib/i18n';

class NoInternationalOffer extends PureComponent<{}, void> {
  styles = getStyles();
  render() {
    const styles = this.styles;
    return (
      <View style={styles.container}>
        <Text style={styles.text}>{I18n.t('NoInternationalOffer.serviceUnavailable')}</Text>
      </View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 10,
    },
    text: {
      color: theme.roaming.notFoundTextColor,
      fontSize: 20,
      textAlign: 'center',
    },
  });

export default NoInternationalOffer;
